import script from "./Revenue.vue?vue&type=script&setup=true&lang=js"
export * from "./Revenue.vue?vue&type=script&setup=true&lang=js"

import "./Revenue.vue?vue&type=style&index=0&id=09cedb90&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09cedb90"]])

export default __exports__